import { render, staticRenderFns } from "./ModalError.vue?vue&type=template&id=56ea8528&scoped=true"
import script from "./ModalError.vue?vue&type=script&lang=js"
export * from "./ModalError.vue?vue&type=script&lang=js"
import style0 from "./ModalError.vue?vue&type=style&index=0&id=56ea8528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea8528",
  null
  
)

export default component.exports